import { render } from "./ExtensionCache.vue?vue&type=template&id=087a3d22"
import script from "./ExtensionCache.vue?vue&type=script&lang=js"
export * from "./ExtensionCache.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__